import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { startTest, startAssessment } from "../../Redux/Action/apiAction";
import { Snackbar, Alert } from "@mui/material";
import { initWebsocket } from "../../Redux/Action/websocketActions";
import store from "../../Redux/store";

const IntroSection = ({ onNext }) => {
  const dispatch = useDispatch();
  const { token: assignmentId } = useParams();

  const [loading, setLoading] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);

  const handleStart = async () => {
    setLoading(true);
    const res = await dispatch(startTest(assignmentId));
    const res2 = await dispatch(startAssessment(assignmentId))
    setLoading(false);

    if (res?.success) {
      initWebsocket(assignmentId, store);
      onNext();
      return;
    }

    if (res?.alreadyCompleted) {
      window.location.href = `/exam/${assignmentId}/complete`;
      return;
    }

    setErrorOpen(true);
  };
  return (
    <>
      <div className="language-left-section" style={{gap:'42px'}}>
        <img src="/images/gappeo-logo.svg" alt="" width={86} height={71} />
        <div className="question-text">
          <h5>Audio test</h5>
          <p style={{maxWidth:'313px', width:'100%'}}>
            This test will record your voice and evaluate listening and reading.
            Click Start to configure your microphone and speakers.
          </p>
          <button onClick={handleStart} style={{width:'224px', height:'48px'}} disabled={loading}>{loading ? "Loading..." : "Start"}</button>
        </div>
      </div>
      <div className="language-right-section">
        <img className="intro-img" src="/images/interview-recording.png" alt="" />
      </div>
      <Snackbar
        open={errorOpen}
        autoHideDuration={3000}
        onClose={() => setErrorOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="error" onClose={() => setErrorOpen(false)}>
          Failed to start test. Please try again.
        </Alert>
      </Snackbar>
    </>
  );
};

export default IntroSection;
